<app-header-one [sticky]="true"></app-header-one>
<div class="container" style="height: 55%;">
    <div class="row" style="height: 100%;">
        <!-- <div class="col-lg-4 col-12 menu-button-container">
            <button class="menu-button" (click)="openLunchMenu()">
                <span>Lunch menu</span><br><br><span>(dine-in only)</span>
            </button> 
        </div> -->
        <div class="col-lg-12 col-12 menu-button-container">
            <button class="menu-button" (click)="openMainMenu()">Menu</button> 
        </div>
        <!-- <div class="col-lg-4 col-12 menu-button-container">
            <button class="menu-button" (click)="openTakeawayMenu()">Takeaway Menu</button> 
        </div> -->
    </div>
</div>
<app-footer-one></app-footer-one>